import React from 'react';
import './home.css';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const Nav= useNavigate();

  const cal=()=>{
    Nav('/cal')
  }
  const loc=()=>{
    Nav('/loc')
  }
  const con=()=>{
    Nav('/cont')
  }
  return (
    <div className="home">
      
      <div className='c4'>
        <br />
        {/*images flowing*/}
        <div className='icon'>

        </div>
        <div>
          {/*samraj */}
        <h1>Welcome to Samraj Solar Energies</h1>
          <p>Samraj Solar Energies is a forward-thinking company dedicated to harnessing the power of the sun to create sustainable energy solutions. As a prominent player in the renewable energy sector, we specialize in designing, installing, and maintaining high-quality solar power systems for both residential and commercial clients. Our mission is to empower communities and businesses to make the switch to clean energy, reducing their carbon footprint while optimizing energy costs.</p>
          <p>We offer a range of services tailored to meet diverse energy needs. From rooftop solar installations to large-scale solar power plants, we bring a commitment to quality and efficiency in every project. With a team of experienced engineers and technicians, we ensure that each installation is customized for maximum output, backed by comprehensive after-sales support and maintenance.</p>
          <p>Samraj Solar Energies uses state-of-the-art technology and top-grade solar panels, ensuring longevity and consistent performance. We handle every aspect of the installation process, from initial consultation and site assessment to permits, installation, and connection to the grid.As advocates of sustainable development, we are dedicated to contributing to a greener planet and helping our clients transition to renewable energy. With Samraj Solar Energies, you can trust that your energy needs are in the hands of experts who care about quality, innovation, and environmental impact.</p>
        </div>

        <br />
        {/*why to choose*/}
        <h1>Why Choose Samraj Solar  Energy?</h1>
        <p>Solar energy is clean, renewable, and abundant. By investing in solar power, you’re not only reducing your electricity bills but also reducing your carbon footprint. With technology that’s rapidly advancing, solar energy is more affordable and accessible than ever before.</p>
        <ol>
          <li>Expertise in Solar Solutions: With years of experience, Samraj Solar Energies provides high-quality solar installations tailored to each client's needs.</li>
          <br/>
          <li>Commitment to Sustainability: By harnessing solar power, Samraj Solar helps you make a positive environmental impact while reducing your carbon footprint.</li>
          <br/>
          <li>Customized Solutions: Our team designs solutions based on your unique energy needs, whether residential, commercial, or industrial.</li>
          <br/>
          <li>Customized Solutions: Our team designs solutions based on your unique energy needs, whether residential, commercial, or industrial.</li>
          <br/>
          <li>Cost-Effective Energy Savings: Lower your electricity bills significantly with our affordable, efficient solar energy systems.</li>
          <br/>
          <li>End-to-End Service: From initial consultation to installation and maintenance, we manage every stage of the process, ensuring a hassle-free experience.</li>
          <br/>
          <li>Certified and Trusted Products: We use only high-quality, certified solar panels and components for long-lasting, reliable power generation.</li>
        </ol>

    {/*the best solutions we are providing*/}
        <br />
        <h1>Our Solutions:</h1>
        <ol>
          <li>Residential Solar Panels – Power your home with clean, green energy and save on your monthly utility bills.</li>
          <li>Commercial Solar Systems – Tailored solar installations for businesses, helping reduce overhead costs while demonstrating a commitment to sustainability.</li>
          <li>Industrial-Scale Solar Plants – Energy solutions designed to meet the high demands of factories and manufacturing plants with robust, scalable systems.</li>
        </ol>        

        </div>

        <div className='c5'>
          <button onClick={cal}>Solar calculator</button>
          <br></br>
          <button onClick={loc}>Location</button>
          <br></br>
          <button onClick={con}>Contact </button>
        </div>
        <br></br>
    </div>
  );
}
